import Vue from 'vue'
import router from './router';
import BeansAdminPlugin from 'beans-admin-plugin';
import config from './admin-plugin-config';
import './theme.scss';
import './global.scss';
import { i18n } from './i18n';
import MultipleRowText from './components/multiple-row-text.vue';
import LocaleString from './components/locale-string';
import ReadOptions from './components/read-options.vue';
import TeamTreeSelect from './components/team-tree-select.vue';
import 'vue-easytable/libs/theme-default/index.css';
import VueEasytable from 'vue-easytable';

Vue.component('app-multiple-row-text', MultipleRowText);
Vue.component('app-locale-string', LocaleString);
Vue.component('app-read-options', ReadOptions);
Vue.component('app-team-tree-select', TeamTreeSelect);

Vue.config.productionTip = false;

Vue.use(BeansAdminPlugin, config);
Vue.use(VueEasytable);

Vue.prototype.$ELEMENT = { size: 'small' }

const app = new Vue({
  router,
  i18n,
  template: '<router-view />'
}).$mount('#app')

export default app;
